module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "section-button"
    }
  }, [_c('button', {
    on: {
      "click": _vm.btnAction
    }
  }, [_vm._v(_vm._s(_vm.btnText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02f3ae82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionButton.vue
// module id = 73
// module chunks = 0